import tokenStore from './token_store'
import { apiUrlFor, rewriteToProxyIfNeeded } from './helpers'

// Store inflight token fetch so we don't request multiple at once
let inFlight = false

const TOKEN_API_URL = rewriteToProxyIfNeeded(apiUrlFor('/api/csrf_token'))

function fetchToken () {
  if (!inFlight) {
    const url = TOKEN_API_URL.toString()
    inFlight = fetch(url, {
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(json => {
        return tokenStore.set(TOKEN_API_URL, json.token)
      })
      .finally(() => {
        inFlight = false
      })
  }
  return inFlight
}

export async function getToken () {
  if (tokenStore.has(TOKEN_API_URL)) {
    return tokenStore.get(TOKEN_API_URL)
  }
  return fetchToken()
}

export async function refreshToken () {
  return fetchToken()
}
